import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, StatusChip, Text } from '@fragments';
import { IconLoader2 } from '@tabler/icons-react';
import PlanMark from '../PlanMark';
import { CHANNEL_ICONS } from '../../../../enums/automations';
import './styles.scss';

// A ready-made automation: the whole card creates its draft. Its plan shows only above the
// creator's own, and never stops the draft (`required_plan`).
export default function TemplateCard({ studio: s, template, onPick, busy, index = 0 }) {
  const { t } = useTranslation('studioAutomations');
  const Glyph = CHANNEL_ICONS[template.channel];
  const pick = () => { if (!busy) onPick(template); };
  return <Card interactive flat className="studio-automation-template studio-automations__rise" style={{ '--rise-index': index }} aria-busy={busy || undefined} onClick={pick}>
    <div className="studio-automation-template__body">
      <Text.label contrast={9}>{template.title}</Text.label>
      <Text.span contrast={6}>{template.summary}</Text.span>
    </div>
    <div className="studio-automation-template__foot">
      <Text.caption contrast={6} left={busy ? <IconLoader2 className="studio-automation-spin" /> : <Glyph />}>{t(`channel_${template.channel}`)}</Text.caption>
      <span className="studio-automation-template__marks">
        {template.popular && <StatusChip.Default text={t('templatePopular')} preserveCase />}
        <PlanMark studio={s} required={template.required_plan} label />
      </span>
    </div>
  </Card>;
}
